/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * События KMS
 */

/**
 * Задача на инициализацию ключей.
 * Очередь key.kms.key_initialization
 */
export type KeyInitializationTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
}
/**
 * Задача на инициализацию ключей.
 * Очередь key.kms.key_initialization
 */
export type KeyInitializationTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Задача на инициализацию ключей.
   * Очередь key.kms.key_initialization
   */
  "KeyInitializationTask": {
    "kind": "class",
    "text": "Задача на инициализацию ключей.\nОчередь key.kms.key_initialization",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}